export const DEFAULT_FOOTER = {
  enabled: true,
  html: "",
  socialLinks: {},
};

export function normalizeFooterPayload(footer) {
  return {
    enabled: footer?.enabled !== false,
    html: typeof footer?.html === "string" ? footer.html : "",
    socialLinks: typeof footer?.socialLinks === "object" && footer?.socialLinks ? footer.socialLinks : {},
  };
}

export function migrateLegacyFooterFromBody(body, footer) {
  const normalizedFooter = normalizeFooterPayload(footer);
  const safeBody = typeof body === "string" ? body : "";

  if (typeof document === "undefined") {
    return { body: safeBody, footer: normalizedFooter, migrated: false };
  }

  const container = document.createElement("div");
  container.innerHTML = safeBody;

  const footerBlocks = Array.from(container.querySelectorAll('[data-bc-section="footer"]'));

  if (!footerBlocks.length) {
    return { body: safeBody, footer: normalizedFooter, migrated: false };
  }

  // Preserve first legacy footer as payload only when footer html is not already set.
  if (!normalizedFooter.html.trim()) {
    normalizedFooter.html = footerBlocks[0]?.innerHTML || "";
  }

  // Remove all legacy footer blocks from body to avoid duplicate rendering.
  footerBlocks.forEach((node) => node.remove());

  return {
    body: container.innerHTML,
    footer: normalizedFooter,
    migrated: true,
  };
}
